import store from "store/store"
import { createComparator, SORT_DIR } from "utils"

export const getSortedEvents = (state = store.getState()) =>
  Object.values(state.events).sort(createComparator("name", SORT_DIR.ASC))
